import "./assets/css/tailwind.css";
import "./assets/css/app.scss";
import "./assets/css/_custom_smartEditor.scss";
import "katex/dist/katex.min.css";
import 'vue3-tour/dist/vue3-tour.css'

import naive from "naive-ui";
import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";
import GlobalFunctions from "./global/functions";
import { katexDirective } from "./global/katex";
import Vue3Tour from 'vue3-tour'

import {
  HelperText,
  UiButton,
  UiDataTable,
  UiEmpty,
  UiModal,
  UiPagination,
  UiTable,
  UiTabs,
  UiCheckboxGroup,
  UiChip,
} from "./components";
import { createPinia } from "pinia";
import { useRoleStore } from "./stores/role";
import { getAccessToken } from "./lib/api";

const app = createApp(App);
const pinia = createPinia();

app.use(router).use(naive).use(GlobalFunctions).use(pinia);
app.use(Vue3Tour);

const components = {
  "helper-text": HelperText,
  "ui-button": UiButton,
  "ui-chip": UiChip,
  "ui-data-table": UiDataTable,
  "ui-empty": UiEmpty,
  "ui-pagination": UiPagination,
  "ui-table": UiTable,
  "ui-tabs": UiTabs,
  "ui-modal": UiModal,
  "ui-checkbox-group": UiCheckboxGroup,
};

Object.entries(components).forEach(([name, component]) => {
  app.component(name, component);
});

app.directive("katex", katexDirective);

// Initialize role store before the first mount so grading menus don't flash open
const bootstrap = async () => {
  const roleStore = useRoleStore(pinia);
  if (getAccessToken()) {
    console.log('App mounted - initializing role store');
    roleStore.setRoleFromUserInfo();
  }
  app.mount("#app");
};

bootstrap();
